import { mapGetters } from 'vuex';

const ResetPassword = {
	name: 'ResetPassword',
	props: {
		method: {
			type: String,
			required: true,
			validator: function(value) {
				return ['post', 'get'].includes(value.toLowerCase());
			},
		},
		action: {
			type: String,
			required: true
		},
	},
	template: `
		<div class="reset-password">
			<div class="reset-password__holder">
				<slot :submit="submit" name="reset-password-top"></slot>
				<form v-on:submit.prevent ref="resetPassword" v-if="!isValid">
					<slot :submit="submit" :isValid="isValid" :hasBeenSent="hasBeenSent" name="reset-password-form"></slot>
				</form>
				<slot name="reset-password-footer" :isValid="isValid" :hasBeenSent="hasBeenSent"></slot>
			</div>
		</div>
	`,
	methods: {
		submit: function() {

			const formData = new FormData(this.$refs.resetPassword);
			let object = {};
			formData.forEach(function(value, key){
			    object[key] = value;
			});

			this.$store.dispatch('resetpassword/resetPassword', {
				method: this.method,
				action: this.action,
				data: object,
			});

		},
	},
	computed: {
		...mapGetters({
			isValid: 'resetpassword/isValid',
			hasBeenSent: 'resetpassword/hasBeenSent',
		})
	},
};

export default ResetPassword;



// WEBPACK FOOTER //
// ../shared/components/reset-password/index.js